import React,{ useEffect,useState,useCallback } from 'react'; // 1
import { useSelector,useDispatch } from 'react-redux';
import { PrimaryButton } from '../components/UIkit';
import {db} from '../firebase/index';
import styled from 'styled-components';
import { push } from 'connected-react-router';
import HTMLReactParser from 'html-react-parser';

const media = {
  sp: '@media(max-width: 650px)'
}

const Tags = styled.div`
    display:flex;
    padding-top: 1em;
    justify-content: center;
`;

const Name = styled.div`
display: flex;
align-items: center;
justify-content: center;
padding: 1.5em 0;
span{
  padding-left: 2em;
}
`;

const Chip = styled.p`
background-color: #FF385C;
border-radius: 0.5rem;
width: 9em;
color: #fff !important;
font-size: 0.9em;
padding: 1em 0;
text-align: center;
margin: 0 0.5em;
`;

const Content = styled.div` 
margin: 0 auto;
 h3 {
   font-size: 1.1em;
   font-weight: bold;
   padding: 1em 0;
   text-align: center;
 }
 p{
   text-align:center;
   color: #FF385C;
  
 }
`;

const Top = styled.div`
margin: 5em 0;
`;

const Item = styled.div`
 padding: 1em 0;
`;

const Main = styled.div`
padding:1em;
text-align: left;
border-radius : 0.5em;
border: solid  2px #ececec;
background-color: #fff;
width: 100%;
max-width: 50em;
margin: 1em auto;
${media.sp} {
  max-width: 80vw;
  border: none;
  padding: 0 0.5em;
  font-size: 1.2em;
   }
`;

const Description = styled.div`
padding:1em;
text-align: left;
border-radius : 0.5em;
border: solid  2px #ececec;
background-color: #fff;
width: 100%;
max-width: 50em;
margin: 1em auto;
${media.sp} {
  max-width: 15.5em;
   }
`;

    // -------------------------------------
    //  returnCodeToBr関数
    // -------------------------------------  
    const returnCodeToBr = (text) => {
      if(text === "") {
        return text
      } else {
        return HTMLReactParser(text.replace(/\r?\n/g,'<br />'))
      }
    };

const ViewNovel = () => {
  const dispatch = useDispatch();
    const selector = useSelector((state) => state);
    const path = selector.router.location.pathname;
    const id = path.split('/post/novel/')[1];

    const [novel, setNovel] = useState(null);

    const goToEdit = useCallback(() => {
      dispatch(push('/post/novels'));
     }, []);

    useEffect (() => {
        db.collection('novel').doc(id).get()
        .then(doc => {
           const data = doc.data();
           setNovel(data)
        })
     }, []);

return(
<div className="common__contents">
    <div className="common__size">
    <Top>
 <h2>投稿作品</h2>
 <Content>
     {novel && (
       <>
     <Item>
     <h3>{novel.title}</h3>
     <Name><Chip>投稿ユーザー</Chip><p><span>{novel.name + '　' + '様'}</span></p></Name>
     <Main>{returnCodeToBr(novel.main)}</Main>
     <Description>{returnCodeToBr(novel.description)}</Description>
     <Tags>
             <Chip>{novel.old}</Chip>
             <Chip>{novel.coupling}</Chip>
            </Tags>
</Item>
</>

   )}
        <PrimaryButton 
     label={"一覧へ戻る"}
     onClick={() => dispatch(goToEdit)}
     />

        </Content>
        </Top>
        </div>
</div>
 )
}

export default ViewNovel;